import { createSelector } from 'reselect';
import * as root from '../';

export const getForAssetModal = createSelector(root.getAssetModalSelectedDepartmentId, root.getDepartmentEntities, (id, deptMap) => deptMap[id]);
